import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo } from "react";
import { HeroV2 } from "@jti/ui";
import { Loader } from "@jti/ui-library";
import { useTrialStatus } from "../../hooks/useTrialStatus/useTrialStatus";
import { useUser } from "../../hooks/useUser/useUser";
import "./HeroBanner.scss";
const HeroBanner = ({ tabletImg, mobileImg, img, heading, loggedAvailableTitle, loggedFinishedTitle, unloggedTitle, availableDescription, finishedDescription, actionButtonAvailableTitle, actionButtonAvailableUrl, actionButtonFinishedTitle = "", actionButtonFinishedUrl, actionButtonLoggedOutTitle, actionButton2AvailableTitle, actionButton2AvailableUrl, actionButton2FinishedTitle = "", actionButton2FinishedUrl, actionButton2LoggedOutTitle, actionButton2LoggedOutUrl, signInUrl, }) => {
    // TODO: replace DOM operations with message bus communication (https://jira.jtiweb.co.uk/browse/DESP-36561)
    const productTeaserTryNowCta = useMemo(() => document.querySelectorAll(".product-teaser-try-now__wrapper"), []);
    const uniqueCategoryIds = useMemo(() => {
        const uniq = Array.from(productTeaserTryNowCta).reduce((acc, cta) => {
            if (!(cta instanceof HTMLElement)) {
                return acc;
            }
            try {
                const categories = JSON.parse(cta.dataset.categories || "[]");
                if (categories.length === 0) {
                    return acc;
                }
                const firstCategoryId = categories[0].id;
                return acc.add(firstCategoryId); // As multiple categories is a misconfiguration, we are only checking the first one
            }
            catch (e) {
                return acc;
            }
        }, new Set());
        return { categoryIds: Array.from(uniq) };
    }, [productTeaserTryNowCta]);
    const { isLoading: isTrialStatusLoading, eligibleCategoryIds, isTrialAvailable } = useTrialStatus(uniqueCategoryIds);
    const { isLoggedIn } = useUser();
    const actionButtonUrl = isTrialAvailable ? actionButtonAvailableUrl : actionButtonFinishedUrl;
    const actionButtonTitle = isTrialAvailable ? actionButtonAvailableTitle : actionButtonFinishedTitle;
    const actionButton2Url = isTrialAvailable ? actionButton2AvailableUrl : actionButton2FinishedUrl;
    const actionButton2Title = isTrialAvailable ? actionButton2AvailableTitle : actionButton2FinishedTitle;
    const ctas = useMemo(() => {
        const ctas = [];
        const freeTrialPathname = window.location.pathname;
        if (actionButtonLoggedOutTitle) {
            ctas.push({
                link: `${signInUrl}?returnUrl=${freeTrialPathname}`,
                additionalBehavior: "onlyForNotLoggedIn",
                label: actionButtonLoggedOutTitle,
                theme: "dark",
                layout: "full",
                tracking: "",
                target: "",
            });
        }
        if (actionButton2LoggedOutTitle && actionButton2LoggedOutUrl) {
            ctas.push({
                link: actionButton2LoggedOutUrl,
                additionalBehavior: "onlyForNotLoggedIn",
                label: actionButton2LoggedOutTitle,
                theme: "light",
                layout: "full",
                tracking: "",
                target: "",
            });
        }
        if (actionButtonUrl && actionButtonTitle) {
            ctas.push({
                link: actionButtonUrl,
                additionalBehavior: "onlyForLoggedIn",
                label: actionButtonTitle,
                theme: "dark",
                layout: "full",
                tracking: "",
                target: "",
            });
        }
        if (actionButton2Title && actionButton2Url) {
            ctas.push({
                link: actionButton2Url,
                additionalBehavior: "onlyForLoggedIn",
                label: actionButton2Title,
                theme: "light",
                layout: "full",
                tracking: "",
                target: "",
            });
        }
        return ctas;
    }, [
        actionButtonLoggedOutTitle,
        actionButton2LoggedOutTitle,
        actionButton2LoggedOutUrl,
        actionButtonUrl,
        actionButtonTitle,
        actionButton2Title,
        actionButton2Url,
        signInUrl,
    ]);
    useEffect(() => {
        const checkEligibility = ({ button, eligibleCategoryIds }) => {
            if (!(button instanceof HTMLElement)) {
                return false;
            }
            try {
                const categories = JSON.parse(button.dataset.categories || "[]");
                if (categories.length === 0) {
                    return false;
                }
                const firstCategoryId = categories[0].id;
                return eligibleCategoryIds.includes(firstCategoryId);
            }
            catch (e) {
                return false;
            }
        };
        productTeaserTryNowCta.forEach((button) => {
            const isEligible = !isTrialStatusLoading && checkEligibility({ button, eligibleCategoryIds });
            button.classList.toggle("hide", !isEligible);
            button
                .closest(".aem-productTeaserComponent__base")
                ?.classList.toggle("aem-productTeaserComponent__base--expanded", isEligible);
        });
    }, [isLoggedIn, eligibleCategoryIds, productTeaserTryNowCta, isTrialStatusLoading]);
    if (isTrialStatusLoading) {
        return (_jsx("div", { className: "hero__loader", children: _jsx(Loader, {}) }));
    }
    return (_jsx(HeroV2, { isContainerWidth: true, data: [
            {
                backgroundType: "image",
                mobileVariant: "transparentContentOnTop",
                desktopImage: {
                    src: img,
                    title: "",
                    alt: "",
                },
                mediumImage: {
                    src: tabletImg || img,
                    title: "",
                    alt: "",
                },
                smallImage: {
                    src: mobileImg,
                    title: "",
                    alt: "",
                },
                videoFileReference: "",
                tabletVideoFileReference: "",
                mobileVideoFileReference: "",
                displayScrollBar: false,
                displayLoader: false,
                legalDisclaimer: "",
                logo: "",
                logoReference: "PLOOM_X",
                clipped: false,
                content: {
                    visibility: "visible",
                    tagLine: heading,
                    title: unloggedTitle,
                    titleLogged: isTrialAvailable ? loggedAvailableTitle : loggedFinishedTitle,
                    subheadline: "",
                    subheadlineLogged: "",
                    text: availableDescription,
                    textLogged: isTrialAvailable ? availableDescription : finishedDescription,
                    cta: ctas,
                    discounts: [],
                },
            },
        ] }));
};
export default HeroBanner;
//# sourceMappingURL=HeroBanner.js.map